<header class="drag-bar" cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <fa-icon icon="arrows-alt"></fa-icon>
    <h1 mat-dialog-title>Vorlagen</h1>
    <span class="spacer"></span>
    <fa-icon class="close-button" icon="times" size="2x" matDialogClose></fa-icon>
</header>
<div class="dialog-container">
    <div class="left-panel">
        <div class="header-buttons">
            <button class="header-button" app-round-button matTooltip="Neue Vorlage anlegen" matTooltipPosition="left" (click)="createTemplate()">
                <fa-icon [icon]="'plus'"></fa-icon>
            </button>
            <button  app-round-button (click)="$event.stopPropagation(); toggleSearch()" [matTooltip]="searchVisible ? 'abbrechen' : 'suchen'">
                <fa-icon [icon]="searchVisible ? 'times' : 'search'"></fa-icon>
            </button>
            <mat-form-field *ngIf="searchVisible"  floatLabel="never"  (click)="$event.stopPropagation()" style="width: 16rem">
                <mat-label>Suche</mat-label>
                <input matInput type="search" [formControl]="searchForm" #searchInput   />
                <button matSuffix class="clear-search" *ngIf="searchForm.value" mat-icon-button aria-label="Clear" (click)="searchForm.setValue('')">
                    <fa-icon icon="times"></fa-icon>
                </button>
            </mat-form-field>
            <button *ngIf="!searchVisible"  app-round-button
                    (click)="templateFilter.Toggle(); $event.stopPropagation();"
                    [matBadge]="FilterAmount$ | async"
                    [matBadgeHidden]="!(FilterAmount$ | async)"
                    matTooltip="Filter"
                    [matBadgeOverlap]="true"
                    class="mat-badge-more-overlay"
            >
                <fa-icon icon="filter"></fa-icon>
            </button>
            <app-filter-card style="position: absolute; z-index:100" [Inline]="true" UnlimitedHeight MaxWidthHundertPercent #templateFilter [Settings]="TemplateFilterSettings | async" [LargeCard]="true"
                              [Values]="TemplateFilterValues$ | async" (ValuesChange)="TemplateFilterValues$.next($event)"></app-filter-card>



        </div>
        <div class="list-container">
            <mat-list>
                <ng-container *ngFor="let item of textTemplateList$ | async">
                    <mat-list-item (click)="selectTemplate(item)"
                                   [class.selected]="selectedTemplate?.template.Id === item.template.Id">
                        <h3 mat-line>{{ item.template.Name }}</h3>
                        <p mat-line class="content-preview">
                            {{ convertToPlainText(item.template.Content) }}
                        </p>
                     <p mat-line>Kategorie: <br> {{ item.tagNames }}</p>
                        <button
                            class="selectTemplateButton"
                            app-round-button
                            matTooltip="Vorlage übernehmen"
                            matTooltipPosition="left"
                            (click)="selectTemplate(item); apply();">

                            <fa-icon [icon]="'file-export'"></fa-icon>
                        </button>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </ng-container>
            </mat-list>
        </div>

    </div>
    <div class="right-panel">
        <div *ngIf="selectedTemplate; else noSelection" class="right-panel-content">
            <h2 class="header" *ngIf="!form.controls.id.value">Vorlage anlegen</h2>
            <h2 class="header" *ngIf="form.controls.id.value">Vorlage bearbeiten</h2>
            <div class="toggle-row">
                <mat-slide-toggle [formControl]="form.controls.private">
                    Private Vorlage&nbsp;
                </mat-slide-toggle>

                <app-hint-icon hint="Öffentliche Vorlagen stehen jedem Mitarbeiter im Unternehmen zur Verfügung."></app-hint-icon>

                <div class="button-group">
                    <button
                        [disabled]="!selectedTemplate"
                        class="header-button"
                        Color="red"
                        app-round-button
                        matTooltip="Löschen"
                        matTooltipPosition="left"
                        (click)="deleteTemplate()">
                        <fa-icon [icon]="'trash'"></fa-icon>
                    </button>

                    <button
                        [Disabled]="!form.dirty || form.invalid"
                        class="header-button"
                        app-round-button
                        matTooltip="Vorlage speichern"
                        matTooltipPosition="right"
                        (click)="saveTemplate()"
                        Color="green">
                        <fa-icon [icon]="'save'"></fa-icon>
                    </button>
                </div>
            </div>

            <div class="detail-row">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Vorlagenname</mat-label>

                    <input
                        matInput
                        type="text"
                        [formControl]="form.controls.name">

                </mat-form-field>
                <app-chip-autocomplete
                    [Options]="textTemplateTags$ | async"
                    [SelectedOptions]="form.controls.tags.value"
                    [OptionTemplate]="optionsTemplate"
                    [MapFn]="tagMapFn"
                    Placeholder="Kategorie"
                    (SelectedOptionsChange)="onTagsChange($event)"
                    (UnknownOptionSubmitted)="onNewTag($event)"
                    class="hover-form">
                </app-chip-autocomplete>
                <app-ck-editor
                    [defaultFontSize]="(defaultFontValues$ | async)?.size"
                    [defaultFontFamily]="(defaultFontValues$ | async)?.family"
                    [Content]="form.controls.content.value"
                    (ContentChange)="onEditorContentChange($event)"
                    [CKEditorConfig]="CKEditorDefaultConfigEmailTemplate"
                ></app-ck-editor>
            </div>

        </div>
        <ng-template #noSelection>
            <p>Bitte erstellen Sie eine neue Vorlage oder wählen Sie eine aus der Liste aus.</p>
        </ng-template>
        <ng-template #optionsTemplate let-Option >
            <div class="tag-container">
                {{ tagMapFn(Option) }}
                <button class="delete-tag" mat-icon-button (click)="DeleteTag(Option, $event)">
                    <fa-icon icon="trash"></fa-icon>
                </button>
            </div>
        </ng-template>
    </div>

</div>
<mat-dialog-actions class="actions">
    <span class="apply"
        [matTooltip]="(form.dirty || form.invalid) ? 'Vorlage muss zuerst gespeichert werden' : ''"
        matTooltipPosition="above">
    <button [Disabled]="form.dirty || form.invalid" app-button  (click)="apply()" >Vorlage übernehmen
    <app-hint-icon *ngIf="defaultTextArea"
        hint="Schriftart, Schriftgröße, Schriftbreite und weitere Formatierungen werden in diesem Textfeld nicht berücksichtigt.">
            </app-hint-icon>
    </button>
    </span>
</mat-dialog-actions>

